export default __webpack_public_path__ + "static/media/cmk2020-program-summary.e5020276.pdf";